import qs from "qs";
export function getDevice(ua) {
  var isNewCarApp = ua.includes("newcar8891");
  var isCarApp = ua.includes("car8891");
  var os;
  var system;
  if (isCarApp) {
    if (/Android/.test(ua)) {
      os = "Android";
    } else {
      os = "iOS";
    }
    system = isNewCarApp ? "newcar" : "usedcar";
  } else {
    os = "touch";
    system = "web";
  }
  return {
    os: os,
    system: system
  };
}
// 获取位置
export function deviceSource(ua) {
  if (typeof window !== "undefined") {
    var userAgent = window.navigator.userAgent;
    return getDevice(userAgent);
  }
  var defaultSource = {
    os: "touch",
    system: "web"
  };
  return ua ? getDevice(ua) : defaultSource;
}
export var sources = deviceSource();
// firebase link生成
function newCarDynamicLink(params) {
  var link = "".concat(window.location.href);
  var appLink = "https://nc8891.page.link/";
  var apn = "com.addcn.newcar8891";
  var amv = 108;
  var isi = 958450485;
  var ibi = "com.addcn.newcar8891";
  var ipbi = "com.addcn.newcar8891";
  var pt = 117277395;
  var ifl = encodeURIComponent("https://itunes.apple.com/app/apple-store/id958450485?utm_source=".concat(params.utm_source, "&utm_medium=newcar Mobile Web&utm_campaign=app download&ct=").concat(params.utm_source, "&mt=newcar Mobile Web&pt=").concat(pt, "&at=app download"));
  var afl = encodeURIComponent("https://play.google.com/store/apps/details?id=com.addcn.newcar8891&referrer=utm_source=".concat(params.utm_source, "&utm_medium=newcar Mobile Web&utm_campaign=app download)"));
  var url = "".concat(appLink, "?link=").concat(link, "?schema=").concat(params.link, "&apn=").concat(apn, "&amv=").concat(amv, "&isi=").concat(isi, "&ibi=").concat(ibi, "&ipbi=").concat(ipbi, "&utm_source=").concat(params.utm_source, "&utm_medium=newcar Mobile Web&utm_campaign=app download&ct=").concat(params.utm_source, "&mt=newcar Mobile Web&pt=").concat(pt, "&at=app download&efr=1&ifl=").concat(ifl, "&afl=").concat(afl);
  return url;
}
function usedCarDynamicLink(params) {
  var host = "https://car8891.page.link";
  var apn = "com.addcn.car8891";
  var isi = "527141669";
  var ibi = "com.Addcn.car8891";
  var pt = "117277395";
  var utmCampaign = "App download";
  var utmMedium = "Usedcar Mobile Web";
  var android = {
    afl: "https://play.google.com/store/apps/details?id=".concat(apn, "&referrer=utm_source=").concat(params.utm_source, "&utm_medium=").concat(utmMedium, "&utm_campaign=").concat(utmCampaign)
  };
  var apple = {
    ifl: "https://itunes.apple.com/app/apple-store/id".concat(isi, "?utm_source=").concat(params.utm_source, "&utm_medium=").concat(utmMedium, "&utm_campaign=").concat(utmCampaign, "&ct=").concat(params.utm_source, "&mt=").concat(utmMedium, "&pt=").concat(pt)
  };
  return "".concat(host, "?").concat(qs.stringify(Object.assign(Object.assign(Object.assign({
    apn: apn,
    isi: isi,
    ibi: ibi,
    pt: pt,
    utmCampaign: utmCampaign,
    utmMedium: utmMedium,
    ct: params.utm_source,
    efr: 1
  }, params), android), apple)));
}
export function dynamicLink(_ref) {
  var type = _ref.type,
    utm_source = _ref.utm_source,
    link = _ref.link;
  var params = {
    link: link,
    utm_source: encodeURIComponent(utm_source)
  };
  if (type === "newCar") {
    return newCarDynamicLink(params);
  }
  if (type === "usedCar") {
    return usedCarDynamicLink(params);
  }
}